import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

const bugsnagClient = bugsnag({
    apiKey: '2bb90864812a03737f5ce337723bd3a2',
    releaseStage: process.env.NODE_ENV,
    notifyReleaseStages: ['production'],
    logger: null,
});

bugsnagClient.use(bugsnagVue, Vue);
bugsnagClient.user = window.Globals.user;
